var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_16976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4095 9.8813C23.1665 8.84414 22.206 8.22184 21.2803 8.50706L15.1357 10.348L7.69136 2.57586C7.35959 2.22948 6.86216 2.09739 6.40226 2.23355C5.63161 2.4617 5.25882 3.33478 5.62702 4.04919L9.7085 11.9686L3.95731 13.6929L2.09386 12.0608C1.83494 11.8341 1.47749 11.7567 1.14795 11.856C0.550593 12.036 0.262786 12.7136 0.548027 13.2685L2.10582 16.2987L2.99685 18.023L4.84834 17.4655L10.993 15.6246L16.0267 14.1207L22.1713 12.2797C23.1086 11.9816 23.6525 10.9185 23.4095 9.8813Z",
    fill: "#328CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8129 7.21579C22.7387 6.93057 23.6991 7.55287 23.9422 8.59003C24.1852 9.62719 23.6413 10.6903 22.704 10.9885L16.5593 12.8294L11.5256 14.3333L5.38098 16.1743L3.5295 16.7317L2.63847 15.0075L1.08067 11.9772C0.795429 11.4223 1.08324 10.7447 1.68059 10.5647C2.01013 10.4654 2.36759 10.5428 2.62651 10.7696L4.48996 12.4016L10.2411 10.6773L6.15966 2.75792C5.79147 2.04351 6.16426 1.17043 6.9349 0.942276C7.3948 0.806121 7.89223 0.938211 8.224 1.28459L15.6683 9.05676L21.8129 7.21579ZM2.6623 19.6486C1.94654 19.6486 1.3663 20.2293 1.3663 20.945C1.3663 21.6608 1.94654 22.2415 2.6623 22.2415H21.9221C22.6378 22.2415 23.2181 21.6608 23.2181 20.945C23.2181 20.2293 22.6378 19.6486 21.9221 19.6486H2.6623Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_16976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/Plane.a658f209a024bf2c7513b9a3fc043f35.svg";
export { ForwardRef as ReactComponent };